"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosAdPlaylistUpdateInputSchema = exports.APosAdPlaylistCreateInputSchema = exports.APosAdPlaylistSchema = void 0;
const zod_1 = require("zod");
const timestamps_schema_1 = require("../../../common/timestamps.schema");
const id_schema_1 = require("../../../common/id.schema");
const enums_1 = require("./enums");
exports.APosAdPlaylistSchema = zod_1.z.object({
    tenantId: id_schema_1.TenantIdSchema,
    playlistId: id_schema_1.EntityIdSchema,
    name: zod_1.z.string().min(1).max(100),
    description: zod_1.z.string().max(500).optional(),
    status: enums_1.APosAdPlaylistStatusSchema.default('draft'),
    version: zod_1.z.number().int().nonnegative().default(0),
    publishedAt: zod_1.z.number().optional(),
    slideOrder: zod_1.z.array(zod_1.z.string()).default([]),
    assignedDisplayIds: zod_1.z.array(zod_1.z.string()).default([]),
    totalDurationSeconds: zod_1.z.number().int().nonnegative().default(0),
    createdBy: zod_1.z.string().min(1),
    updatedBy: zod_1.z.string().min(1),
}).merge(timestamps_schema_1.TimestampsSchema);
exports.APosAdPlaylistCreateInputSchema = zod_1.z.object({
    name: zod_1.z.string().min(1).max(100),
    description: zod_1.z.string().max(500).optional(),
});
exports.APosAdPlaylistUpdateInputSchema = zod_1.z.object({
    name: zod_1.z.string().min(1).max(100).optional(),
    description: zod_1.z.string().max(500).optional(),
    status: enums_1.APosAdPlaylistStatusSchema.optional(),
    slideOrder: zod_1.z.array(zod_1.z.string()).optional(),
    assignedDisplayIds: zod_1.z.array(zod_1.z.string()).optional(),
});
//# sourceMappingURL=ad-playlist.schema.js.map